import { createFileRoute } from '@tanstack/react-router';
import { AnalyticsPage } from '@/pages/analytics';

export const Route = createFileRoute('/analytics')({
  staticData: { permission: 'analytics.view' },
  component: AnalyticsPage,
});
